import { useMemo, useState } from "react";
import { ColorButton } from "../../../button/colorButton/ColorButton";
import { INoteViewModel } from "../models/noteModel";
import { Note } from "./Note";
import styles from "./NotesBlock.module.scss";
import { AppDialog } from "../../../AppDialog/AppDialog";
import { NoteAddUpdateDialog } from "./NoteAddUpdateDialog";
import { classNames } from "primereact/utils";
import {
  IfFalse,
  IfTrue,
  RenderWhen,
} from "../../../../infrastructure/components/RenderWhen";
import { useApiMutation } from "../../../../infrastructure/hooks/useApiMutation";
import { IconType } from "../../../../icons/Icon";
import { QueryKey } from "@tanstack/react-query";

interface INotesBlockProps {
  className?: string;
  notes?: INoteViewModel[];
  entityId: number;
  createEndpoint: string;
  updateEndpoint: string;
  deleteEndpoint: string;
  invalidateKeys: QueryKey[];
  noResultsLabel: string;
}

export const NotesBlock = ({
  className,
  notes,
  entityId,
  createEndpoint,
  updateEndpoint,
  deleteEndpoint,
  invalidateKeys,
  noResultsLabel,
}: INotesBlockProps) => {
  const [showDialog, setShowDialog] = useState(0);
  const { mutate } = useApiMutation();
  const noteToEdit = useMemo(
    () => notes?.find((n) => n.id === showDialog),
    [showDialog]
  );

  const onNoteDelete = (noteId: number) => {
    mutate({
      endpoint: `${deleteEndpoint}?noteId=${noteId}`,
      method: "delete",
      globalIsLoading: false,
      invalidateKeys,
    });
  };

  return (
    <div className={classNames(styles.root, className)}>
      <RenderWhen condition={!!notes && notes.length > 0}>
        <IfTrue>
          {notes?.map((x) => (
            <Note
              key={x.id}
              note={x}
              onEditClick={setShowDialog}
              onDelete={onNoteDelete}
            />
          ))}
        </IfTrue>
        <IfFalse>
          <span className={styles.root_no_notes}>{noResultsLabel}</span>
        </IfFalse>
      </RenderWhen>

      <ColorButton
        label={"Добави бележка"}
        backgroundColorHex={"#10b981"}
        textColorHex={"#fff"}
        onClick={() => setShowDialog(-1)}
        icon={IconType.Plus2}
      />

      <AppDialog
        header={!!noteToEdit ? "Редактиране на бележка" : "Добавяне на бележка"}
        visible={showDialog !== 0}
        onHide={() => setShowDialog(0)}
      >
        <NoteAddUpdateDialog
          entityId={entityId}
          createEndpoint={createEndpoint}
          updateEndpoint={updateEndpoint}
          invalidateKeys={invalidateKeys}
          note={noteToEdit}
          onSuccess={() => setShowDialog(0)}
        />
      </AppDialog>
    </div>
  );
};
